import { useEffect, useRef } from "react";

const HtmlPopup = ({ isOpen, toggleDialog, templateContent }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (iframeRef.current && templateContent) {
      const doc = iframeRef.current.contentWindow.document;
      doc.open();
      doc.write(`
        <html>
          <head>
            <style>
              .no-wrap{white-space: nowrap;}
                    .checkbox {
                            display: inline-block;
                            width: 15px;
                            height: 13px;
                            background-size: cover;
                            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAT0lEQVR4nGNgGAUkAg8GBobHDAwM/8nEj6Bm4ASPKDD8P5IlOAFMEbngPyH9oxb8Hw0iQmA0iAiC0SAaAkH0iNbFtQeFljwiVOGMAgZ0AAATHXu+9Uu+uwAAAABJRU5ErkJggg==');
                                padding: 2px;
                                  margin-left: 2px;
                          }
                          .checked {
                            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAj0lEQVR4nO2VOw6AIBAF5xISj+RV5LhS2ONBsMGEbMSVX6UvoWKZSV4IwJ/CLMABhMrlIyMb3wAPiSSba6g2QTv/PYEB1lECA7g4b3sLJmCLszsw9xRMGXiVYI1V3NXixF6xwAqQBi8WSKBT4MUC2Xe46bxZkEo0eNMtMg+1dBG8jXp++HO9NEq89uH8QeYE/eCX+GLofnAAAAAASUVORK5CYII=');
                          }
                        
                          .unchecked {
                            
                          }
                        body { font-family: Arial, sans-serif;font-size:14px; }
                        .page-break { page-break-after: always; }
                        .no-break { page-break-inside: avoid;}
                        table td{vertical-align: top;padding: 2px;padding-left: 5px}
            </style>
          </head>
          <body>${templateContent}</body>
        </html>
      `);
      doc.close();
    }
  }, [templateContent, isOpen]);

  return (
    isOpen && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="relative bg-white w-11/12 max-w-4xl p-6 rounded shadow-lg overflow-auto max-h-screen">
          <button
            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            onClick={toggleDialog}
          >
            ✖
          </button>
          <iframe ref={iframeRef} title="HTML Preview" className="w-full h-[90vh] border"></iframe>
        </div>
      </div>
    )
  );
};

export default HtmlPopup;
